import { HcmusDesktop } from "./HcmusDesktop";
import { UCalgaryDesktop } from "./UCalgaryDesktop";

function EducationDesktop() {
  return (
    <section id="education" className="pt-[80px] mb-[60px]">
      <div className="container items-start flex flex-col">
        <div className="flex flex-row items-center">
          <p className="text-[24px] font-medium mb-8">Education</p>
        </div>

        <div className="flex flex-col ">
          <UCalgaryDesktop />
          <HcmusDesktop />
        </div>
      </div>
    </section>
  );
}

export default EducationDesktop;
